import { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from '@azure/msal-browser';
import { apiRequest } from '../authconfig';

const Login = () => {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    useEffect(() => {
        const handleLogin = async () => {
            if (!isAuthenticated && inProgress === InteractionStatus.None) {
                try {
                    await instance.handleRedirectPromise();
                    const accounts = instance.getAllAccounts();
                    if (accounts.length === 0) {
                        await instance.loginRedirect(apiRequest);
                    }
                } catch (error) {
                    console.error("Error during authentication:", error);
                    alert(error.message);
                }
            }
        };

        handleLogin();
    }, [inProgress, isAuthenticated, instance]);


    return null;
}

export default Login;
